import { Debug } from "./Debug";
import { Layout } from "./Layout";
import { State } from "./State";
import { Data } from "./Data";
import { Anim } from "./Anim";
import { Drag } from "./Drag";

export interface ModuleCollection {
  debug: any;
  layout: Layout;
  state: any;
  drag: Drag;
  data: Data;
}

export class Base {
  static initModules(
    ref: any,
    data: any,
    modulesArr: string[] = ["data", "layout", "debug", "state", "anim", "drag"]
  ): ModuleCollection {
    var res: any = {};
    ref.name = data.name;
    ref.itemData = data;
    modulesArr.forEach((element: string) => {
      switch (element.toLowerCase()) {
        case "layout":
          res[element] = new Layout(ref, data);
          break;
        case "debug":
          res[element] = new Debug(ref, data);
          break;
        case "state":
          res[element] = new State(ref, data);
          break;
        case "data":
          res[element] = new Data(ref, data);
          break;
        case "anim":
          res[element] = new Anim(ref, data);
          break;
        case "drag":
          res[element] = new Drag(ref, data);
          break;
      }
    });
    return res as ModuleCollection;
  }
}
